<template>
  <div id="Actia">
    <SovecoNavBar />
    <div class="box has-text-centered">
      <span class="button is-success" @click="doGetActia()">
        Vai al sito ACTIA</span
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
export default {
  name: 'Actia',
  mixins: [UtilityMixin],
  data() {
    return {
      apiServer: '',
      auth: null,
      prefs: null,
      actiaData: {},
      windowHeight: 0,
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()

    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }
    vm.$nextTick(function () {
      const vm = this
      vm.doGetActia()
      vm.$router.push({
        path: 'map',
      })
    })
  },
  methods: {
    openUrl() {
      const vm = this
      let url = 'http://actia-apps-fleet.easyvista.com/s/AF3_SH' //'https://portal.actiafleet.com'
      // let url =
      //   'https://www.actiafleet.com/bauth.html?a=' +
      //   vm.actiaData.token +
      //   '&b=https://www.actiafleet.com/'
      window.open(url, '_blank')
    },
    async doActiaAuth() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'doactia',
          {
            username: vm.actiaData.login,
            password: vm.actiaData.password,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response && response.data.length > 0) {
          vm.actiaData.cos_utente = vm.auth.cod
          vm.actiaData.token = response.data
          vm.actiaData.ts = Math.floor(Date.now() / 1000)
          ServiceBus._doInsertCredenzialiActia(vm.actiaData)
          vm.openUrl()
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doGetActia() {
      const vm = this

      let now_ts = Math.floor(Date.now() / 1000)
      let delta = now_ts - vm.actiaData.ts
      if (delta > 10800) {
        await vm.doActiaAuth()
      } else {
        vm.openUrl()
      }
    },
  },
}
</script>
